import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useIntl } from 'ha/i18n';
import { useIdP } from 'ha/modules/Authentication/useIdP';
import { getImpersonatingAdmin } from '../selectors';
import { impersonateUser } from '../actions';

interface ImpersonatingAdmin {
  id: number;
  name: string;
}

interface ChildrenProps {
  impersonatingAdmin: ImpersonatingAdmin | null;
  onStop: () => void;
}

interface Props {
  children: React.FunctionComponent<ChildrenProps>;
}

export function Impersonation({ children }: Props) {
  const { urlResolver } = useIntl();
  const { isIdPEnabled } = useIdP();

  const dispatch = useDispatch();
  const impersonatingAdmin = useSelector(getImpersonatingAdmin);

  const [impersonatingAdminState, setImpersonatingAdminState] =
    React.useState<ImpersonatingAdmin | null>(null);

  const handleStop = React.useCallback(() => {
    dispatch(impersonateUser(0, urlResolver.getAdminPagesUrl(), isIdPEnabled));
  }, [dispatch, urlResolver, isIdPEnabled]);

  React.useEffect(() => {
    setImpersonatingAdminState(impersonatingAdmin);
  }, [impersonatingAdmin]);

  return children({
    impersonatingAdmin: impersonatingAdminState,
    onStop: handleStop,
  });
}
